import { GetContacts, GetOrganizationContacts } from '../../api';

// Helpers
import { transformContactRecord } from '../../containers/Admin/Contacts/helpers';

// Types
import { IContactRecord, TableQueryParams } from '../../types';

export async function fetchPaginatedContactsData({ options }: { options: TableQueryParams }) {
    const allContacts = await GetContacts(options);

    if (allContacts) {
        const { contacts, totalRecords } = allContacts;

        return {
            rows: contacts,
            pageCount: Math.ceil(totalRecords / options.pageData.size)
        };
    } else {
        return {
            rows: [],
            pageCount: 0
        };
    }
}

export async function fetchOrganizationContactsData({ clientId }: { clientId?: string }) {
    if (clientId) {
        const allContacts = await GetOrganizationContacts({ orgId: clientId });

        if (allContacts) {
            const { contacts } = allContacts;
            // const data = transformOrgs(contacts);

            return {
                rows: contacts
            };
        }
    }
    return {
        rows: []
    };
}

export function transformOrgs(response: IContactRecord[]) {
    return response.map(transformContactRecord);
}
